var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpAndSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_16110_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 10.3534C12.75 10.0941 12.75 9.9645 12.789 9.849C12.9024 9.5133 13.2014 9.3831 13.5008 9.24667C13.8375 9.0933 14.0058 9.01665 14.1726 9.00315C14.362 8.98785 14.5517 9.02865 14.7135 9.11947C14.9281 9.23985 15.0777 9.46867 15.2309 9.65475C15.9384 10.5141 16.2922 10.9438 16.4216 11.4177C16.5261 11.8 16.5261 12.1999 16.4216 12.5823C16.2329 13.2734 15.6364 13.8528 15.1948 14.389C14.969 14.6633 14.8561 14.8005 14.7135 14.8805C14.5517 14.9713 14.362 15.0121 14.1726 14.9968C14.0058 14.9833 13.8375 14.9067 13.5008 14.7533C13.2014 14.6169 12.9024 14.4867 12.789 14.151C12.75 14.0355 12.75 13.9059 12.75 13.6466V10.3534Z",
    stroke: "#A8ABAC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.125 15.75C8.16052 16.75 9.83948 16.75 10.875 15.75",
    stroke: "#A8ABAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.25 10.3534C5.25 10.027 5.24084 9.73363 4.97693 9.50413C4.88095 9.42065 4.75369 9.36268 4.49918 9.24673C4.16251 9.09343 3.99417 9.01678 3.82737 9.00328C3.32693 8.96278 3.05769 9.30433 2.7691 9.6548C2.06156 10.5142 1.7078 10.9438 1.57835 11.4177C1.47388 11.8 1.47388 12.1999 1.57835 12.5823C1.76715 13.2734 2.36364 13.8526 2.80516 14.3889C3.08347 14.7269 3.34933 15.0354 3.82737 14.9967C3.99417 14.9832 4.16251 14.9065 4.49918 14.7532C4.75369 14.6373 4.88095 14.5793 4.97693 14.4958C5.24084 14.2663 5.25 13.973 5.25 13.6465V10.3534Z",
    stroke: "#A8ABAC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.5 12V9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9L16.5001 12",
    stroke: "#A8ABAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16110_1689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAndSupport);
export default __webpack_public_path__ + "static/media/helpAndSupport.34f5a070680a19fb6f093a5356ad9b7a.svg";
export { ForwardRef as ReactComponent };